import React from 'react';
import { Facebook, Instagram, Star } from 'lucide-react';
export function Footer() {
  const footerLinks = {
    services: ['Residential & Commercial Junk Removal', 'Garage Cleaning & Organization', 'Furniture & Appliance Pickup', 'Same-Day & Next-Day Service'],
    company: ['About', 'How It Works', 'Service Area', 'Reviews', 'Blog'],
    contact: [{
      label: 'Phone: (425) 269-7387',
      href: 'tel:4252697387'
    }, {
      label: 'Text Us: (425) 269-7387',
      href: 'sms:4252697387'
    }, {
      label: 'Email: info@azjunknerds.com',
      href: 'mailto:info@azjunknerds.com'
    }, {
      label: 'Hours: Mon-Sat 7AM-7PM',
      href: null
    }],
    legal: [{
      label: 'Privacy Policy',
      href: '#'
    }, {
      label: 'Terms of Service',
      href: '#'
    }, {
      label: 'Accessibility',
      href: '#'
    }]
  };
  return <footer className="relative bg-navy pt-16 pb-8 overflow-hidden" data-id="element-30">
      {/* Star sparkle pattern overlay */}
      <div className="absolute inset-0 opacity-5" data-id="element-31">
        {[...Array(30)].map((_, i) => <div key={i} className="absolute w-1 h-1 bg-lime rounded-full" style={{
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animation: `twinkle ${2 + Math.random() * 3}s infinite ${Math.random() * 2}s`
      }} data-id="element-32" />)}
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-33">
        {/* ROW 1: Two-column split on desktop, stacked on mobile */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 mb-10" data-id="element-34">
          {/* LEFT COLUMN: Logo, tagline, social */}
          <div className="flex flex-col items-center lg:items-start lg:w-[30%] shrink-0" data-id="element-35">
            <img src="https://cdn.magicpatterns.com/uploads/tAQ2hBAg2YykrLwSQc6Y3H/AZ-JunkNerds-logo-v2.png" alt="AZ Junk Nerds" className="h-[120px] md:h-[140px] w-auto mb-4 drop-shadow-[0_0_20px_rgba(163,230,53,0.3)]" data-id="element-36" />
            <p className="text-white/70 text-sm leading-relaxed mb-6 text-center lg:text-left max-w-xs" data-id="element-37">
              Phoenix's nerdiest junk haulers. Fast. Clean. Affordable.
            </p>
            <div className="flex items-center gap-3" data-id="element-38">
              <a href="https://instagram.com/azjunknerds" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-lime/10 border border-lime/30 flex items-center justify-center hover:bg-lime/20 hover:border-lime transition-all" data-id="element-39">
                <Instagram className="w-4 h-4 text-lime" data-id="element-40" />
              </a>
              <a href="https://facebook.com/azjunknerds" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-lime/10 border border-lime/30 flex items-center justify-center hover:bg-lime/20 hover:border-lime transition-all" data-id="element-41">
                <Facebook className="w-4 h-4 text-lime" data-id="element-42" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-lime/10 border border-lime/30 flex items-center justify-center hover:bg-lime/20 hover:border-lime transition-all" data-id="element-43">
                <Star className="w-4 h-4 text-lime fill-lime" data-id="element-44" />
              </a>
              <span className="text-white/50 text-xs ml-1" data-id="element-45">@azjunknerds</span>
            </div>
          </div>

          {/* RIGHT COLUMN: 4 link columns */}
          <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-46">
            {/* Services */}
            <div data-id="element-47">
              <h3 className="font-heading text-sm text-lime tracking-wider mb-4 uppercase" data-id="element-48">
                SERVICES
              </h3>
              <ul className="space-y-2" data-id="element-49">
                {footerLinks.services.map(link => <li key={link} data-id="element-50">
                    <a href="#services" className="text-white/70 hover:text-lime transition-colors text-[15px] leading-relaxed" data-id="element-51">
                      {link}
                    </a>
                  </li>)}
              </ul>
            </div>

            {/* Company */}
            <div data-id="element-52">
              <h3 className="font-heading text-sm text-lime tracking-wider mb-4 uppercase" data-id="element-53">
                COMPANY
              </h3>
              <ul className="space-y-2" data-id="element-54">
                {footerLinks.company.map(link => <li key={link} data-id="element-55">
                    <a href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="text-white/70 hover:text-lime transition-colors text-[15px]" data-id="element-56">
                      {link}
                    </a>
                  </li>)}
              </ul>
            </div>

            {/* Contact */}
            <div data-id="element-57">
              <h3 className="font-heading text-sm text-lime tracking-wider mb-4 uppercase" data-id="element-58">
                CONTACT
              </h3>
              <ul className="space-y-2" data-id="element-59">
                {footerLinks.contact.map(item => <li key={item.label} data-id="element-60">
                    {item.href ? <a href={item.href} className="text-white/70 hover:text-lime transition-colors text-[15px]" data-id="element-61">
                        {item.label}
                      </a> : <span className="text-white/70 text-[15px]" data-id="element-62">
                        {item.label}
                      </span>}
                  </li>)}
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-63">
              <h3 className="font-heading text-sm text-lime tracking-wider mb-4 uppercase" data-id="element-64">
                LEGAL
              </h3>
              <ul className="space-y-2" data-id="element-65">
                {footerLinks.legal.map(item => <li key={item.label} data-id="element-66">
                    <a href={item.href} className="text-white/70 hover:text-lime transition-colors text-[15px]" data-id="element-67">
                      {item.label}
                    </a>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        {/* ROW 2: Bottom Bar */}
        <div className="pt-6 border-t border-lime/20" data-id="element-68">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-sm text-white/50" data-id="element-69">
            <p className="text-center md:text-left" data-id="element-70">
              © 2026 AZ Junk Nerds. All rights reserved.
            </p>
            <p className="text-center md:text-right" data-id="element-71">
              Licensed & Insured in Arizona.
            </p>
          </div>
        </div>
      </div>

      <style data-id="element-72">{`
        @keyframes twinkle {
          0%, 100% { opacity: 0.2; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.5); }
        }
      `}</style>
    </footer>;
}